<template>
  <v-card class="com-mb-card">
    <v-col class="com-mb-card-contents pa-0">
      <v-row no-gutters class="pa-2">
        <span class="pre-form"
          ><a
            class="link fld-nav"
            :href="floodedNav"
            target="_blank"
            @click="clickInuDetail"
            >{{ text.fldNav }}</a
          ></span
        >
      </v-row>
    </v-col>
  </v-card>
</template>
<script>
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "iu-link",
  data() {
    return {
      hazardList: [],
      floodedNav: "https://suiboumap.gsi.go.jp/",
      /** 文字列リソース */
      text: {
        fldNav: "浸水ナビ（国土地理院）",
      },
    };
  },
  methods: {
    /** 詳細な浸水想定情報クリック */
    clickInuDetail() {
      // アクセスログ出力
      PageLog.log({
        page_log: "inun_navi",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pre-form {
  white-space: pre;
  .fld-nav {
    text-decoration: none;
  }
}
</style>